import React from 'react';
import { Button, Form, FormGroup } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Loader from '../../../common/Loader';
import FormItem from '../../../common/forms/FormItem';
import { isRequired } from '../../../../utils/validators';
import FormFooter from '../../../common/forms/FormFooter';
import TextInput from '../../../common/forms/input/TextInput';

export const BillReversionForm = ({ handleSubmit, loading, onCancel }) => {
  if (loading) {
    return <Loader />;
  }

  return (
    <>
      <Form onSubmit={handleSubmit}>
        <FormGroup row>
          <FormItem label="Observaciones">
            <Field
              name="comment"
              component={TextInput}
              type="textarea"
              placeholder="Observaciones"
              validate={[isRequired]}
            />
          </FormItem>
        </FormGroup>

        <FormFooter
          saveButtonColor="info"
          saveButtonText="Generar Reversión"
          saveButtonDisabled={loading}
          saveButtonIcon={loading ? 'fa fa-spinner fa-spin' : 'fa fa-pencil'}
        >
          <Button color="primary" onClick={onCancel}>
            Cancelar
          </Button>
        </FormFooter>
      </Form>
    </>
  );
};

BillReversionForm.propTypes = {
  loading: PropTypes.bool,
  handleSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

BillReversionForm.defaultProps = {
  loading: false,
};

const mapStateToProps = (state) => ({
  loading: !state.AccountingUnit.Billing.getIn([
    'current',
    'activity',
  ]).isEmpty(),
});

const formComponent = reduxForm({
  form: 'BillReversionForm',
})(BillReversionForm);

export default connect(mapStateToProps, null)(formComponent);
